<!-- 废弃 -->
<template>
	<div>
		<myheader :backFlag="true" headTitle="创建企业"></myheader>
		<div class="all_main">
			<div class="all_content_padding">
				<div class="all_tips_content_card">
					<div class="text12 textcolor999 font_weight_bold">请输入想要创建的企业</div>
					<div class="all_tips_red text14 textcolor666 margin_top_10">企业名称</div>
					<div class="all_tips_input" :class="{ isfocus: nameFocus }">
						<input class="my_input text14 textcolor333" v-model="enterpriseName" @focus="getFocus(1)"
							@blur="onblur(1)" />
						<button class="my_button text14">搜索</button>
					</div>
					<div class="all_tips_red text14 textcolor666 margin_top_10">社会统一信用代码</div>
					<div class="all_tips_input" :class="{ isfocus: codeFocus }">
						<input class="my_input text14 textcolor333" v-model="enterpriseCode" @focus="getFocus(2)"
							@blur="onblur(2)" />
					</div>
				</div>
				<div class="all_tips_content_card margin_top_10">
					<div class="text12 textcolor333">为满足您的业务需求，需要您使用企业认证服务，服务可能采集如下信息：</div>
					<div class="text12 textcolor333 margin_top_5">• 企业四要素：企业名称、统一社会信用代码、 法定代表人姓名、身份证号</div>
					<div class="text12 textcolor333">• 操作人人脸视频（仅法定代表人人脸识别获取）</div>
					<div class="text12 textcolor333">• 法定代表人授权书（仅法定代表人授权书认证获取）</div>
					<van-checkbox class="text12 textcolor333 margin_top_5"
						v-model="checked">我已阅读并同意《实名认证服务协议》</van-checkbox>
				</div>
			</div>
			<div class="all_tips_bottom_card">
				<button class="all_button24 width_100 text16" @click="jump()">下一步</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Checkbox
	} from 'vant';
	//Vue.use(Checkbox);
	export default {
		components: {
			[Checkbox.name]: Checkbox,
		},
		data() {
			return {
				nameFocus: false,
				codeFocus: false,
				enterpriseName: '',
				enterpriseCode: '',
				checked: false,
			}
		},
		methods: {
			getFocus(index) {

			},
			onblur(index) {

			},
			jump() {
				this.$router.push({
					path: '/selectenterpriseauthstyle'
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
</style>